
export const authHelper = {
    // Obtener credenciales del localStorage
    getCredentials() {
        const credentials = localStorage.getItem('credentials');
        return credentials ? JSON.parse(credentials) : null;
    },

    // Verificar si el token ha expirado
    isTokenExpired() {
        const credentials = this.getCredentials();
        if (!credentials || !credentials.expiresAt) return true;
        return Date.now() > credentials.expiresAt;
    },

    // Cerrar sesión
    logout() {
        localStorage.removeItem('credentials');
        window.location.href = '/login?sessionExpired=true';
    },

    // Obtener token para las peticiones
    getAuthToken() {
        const credentials = this.getCredentials();
        return credentials?.token || null;
    }
};